

export const config = {
  urlPlatform: "https://app.commenter.ai",
  urlCommenter: "https://gpt3.socialpostmate.info/gpt3",
  urlPlatformWP: "contentful",
  urlSales: "https://commenter.ai",

  /* Local link  */
  // urlPlatform: "http://localhost:3012",
  // urlCommenter: "https://commenter.ai/gpt3",
  // urlPlatformWP: "contentful",
  // urlSales: "http://localhost:3000",

};

export const urlPaths = {
  homepage: "/testnew",
  comingsoon: "/new",
  comingsoon2: "/short",
  homenew: "/",
  commenterhome: "/become-a-partner",
  thankYouPage: "/thank-you",
  login: "/login",
  register: "/register",
  dashboardComingSoon: "/crm",
  proplan: "/proPlan",
  professional: "/professional",
  blackFriday: "/BlackWednesday",
  yearlyPlan: "/YearlyPlan",
  YearlyPlanEmail: "/YearlyPlanEmail",
  successRegister: "/success-register",
  requestNewPassword: "/request-new-password",
  newPassword: "/new-password",
  activateAccount: "/activate-account",
  unauthorized: "/unauthorized",
  sessionExpired: "/session-expired",
  platform: "/platform",
  engagement: "/engagement",
  marketplace: "/marketplace",
  contactUs: "/contact-us",
  settings: "/settings",
  getComments: "/get-comments",
  achievements: "/achievements",
  requestFeature: "/request-feature",
  aboutUs: "/about",
  results: "/results",
  feature: "/feature",
  tutorial: "/tutorials",
  custom: "/custom",
  time: "/time",
  pricing: "/pricing",
  successSubscription: "/success-subscription",
  privacyPolicy: "/privacy-policy",
  termsOfService: "/terms-of-service",
  focusDataPolicy: "/focus/data-usage",
  checkoutRedirect: "/checkout",
  surveyFinish: "/survey",
  savedComments: "/my-comments",
  postedComments: "/posted-comments",
  finalStep: "/login-extension",
  posts: "/posts",
  listposts: "/posts/list",
  peopleLists: "/posts/people",
  peopleSingle: "/posts/people/:id",
  qrLogin: "/qr-login",
  messages: "/messages",
  preferences: "/preferences",
  dashboard: "analytics-dashboard",
  notFound: "*",
};

/**
 * Single kill switch for the mailbox/calendar integrations (Gmail, Outlook,
 * Google/Outlook Calendar). Turned off for now; flipping it back to `true`
 * restores the onboarding screens and the settings cards with no other work.
 */
export const featureFlags = {
  emailAndCalendarIntegrations: false,
  /**
   * The login/register reCAPTCHA. It was never verified server-side, so it only
   * slowed real people down; the API now rate-limits those endpoints instead.
   * Flip to `true` to show the widget again.
   */
  recaptcha: false,
};

export const USER_SUBSCRIPTION = {
  TRIAL: "trialing",
  ACTIVE: "active",
  INACTIVE: "inactive",
  CANCELED: "canceled",
};

const sanitizeEnv = (value) => {
  if (!value) return "";
  return String(value).trim();
};

export const appleAuthConfig = {
  clientId: sanitizeEnv(process.env.REACT_APP_APPLE_CLIENT_ID),
  redirectURI: sanitizeEnv(process.env.REACT_APP_APPLE_REDIRECT_URI),
  scope: sanitizeEnv(process.env.REACT_APP_APPLE_SCOPE) || "name email",
  state: sanitizeEnv(process.env.REACT_APP_APPLE_STATE),
};

export const firebaseConfig = {
  apiKey: "AIzaSyDY0VEGfgCj1k_N3ZH8UvaUku5PG69UjeU",
  authDomain: "commenter-ai-8afcf.firebaseapp.com",
  projectId: "commenter-ai-8afcf",
  storageBucket: "commenter-ai-8afcf.appspot.com",
  messagingSenderId: "633288715928",
  appId: "633288715928:web:0064e7150ab3790e07aaed",
};

export const isFirebaseConfigured = () =>
  Object.values(firebaseConfig).every(Boolean);
